import { fetchApiPublic } from "./fetchStudioApi";

export const fetchServerUp = async () => {
  const result = await fetchApiPublic({ path: "/up", method: "GET" });
  return result && result.up === "yes";
};
